import React from 'react';

export const HomeIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M1 10L3 8M3 8L10 1L17 8M3 8V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H7M17 8L19 10M17 8V18C17 18.2652 16.8946 18.5196 16.7071 18.7071C16.5196 18.8946 16.2652 19 16 19H13M7 19C7.26522 19 7.51957 18.8946 7.70711 18.7071C7.89464 18.5196 8 18.2652 8 18V14C8 13.7348 8.10536 13.4804 8.29289 13.2929C8.48043 13.1054 8.73478 13 9 13H11C11.2652 13 11.5196 13.1054 11.7071 13.2929C11.8946 13.4804 12 13.7348 12 14V18C12 18.2652 12.1054 18.5196 12.2929 18.7071C12.4804 18.8946 12.7348 19 13 19M7 19H13"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Calendar = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M6 5V1V5ZM14 5V1V5ZM5 9H15H5ZM3 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Branding = (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path
      d="M5.70833 18.25C4.69167 18.25 3.71665 17.8637 2.99776 17.1761C2.27887 16.4884 1.875 15.5558 1.875 14.5833V3.58333C1.875 3.0971 2.07693 2.63079 2.43638 2.28697C2.79582 1.94315 3.28334 1.75 3.79167 1.75H7.625C8.13333 1.75 8.62084 1.94315 8.98029 2.28697C9.33973 2.63079 9.54167 3.0971 9.54167 3.58333V14.5833C9.54167 15.5558 9.1378 16.4884 8.41891 17.1761M5.70833 18.25C6.725 18.25 7.70002 17.8637 8.41891 17.1761M5.70833 18.25H17.2083C17.7167 18.25 18.2042 18.0568 18.5636 17.713C18.9231 17.3692 19.125 16.9029 19.125 16.4167V12.75C19.125 12.2638 18.9231 11.7975 18.5636 11.4536C18.2042 11.1098 17.7167 10.9167 17.2083 10.9167H14.963M8.41891 17.1761L12.4849 13.2869L16.5509 9.39775C16.9102 9.05395 17.1121 8.58772 17.1121 8.10158C17.1121 7.61545 16.9102 7.14922 16.5509 6.80542L13.8398 4.21217C13.4804 3.86847 12.9929 3.67539 12.4847 3.67539C11.9765 3.67539 11.4891 3.86847 11.1296 4.21217L9.54167 5.73108M5.70833 14.5833H5.71792"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Members = (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path
      d="M10 3.17258C10.5374 2.58867 11.2477 2.17545 12.0362 1.98789C12.8247 1.80033 13.6542 1.84733 14.4142 2.12264C15.1741 2.39794 15.8286 2.88851 16.2905 3.52904C16.7524 4.16958 16.9998 4.92973 16.9998 5.70833C16.9998 6.48694 16.7524 7.24708 16.2905 7.88762C15.8286 8.52816 15.1741 9.01872 14.4142 9.29403C13.6542 9.56934 12.8247 9.61634 12.0362 9.42878C11.2477 9.24122 10.5374 8.82799 10 8.24408M13 19.125H1V18.1667C1 16.6417 1.63214 15.1791 2.75736 14.1008C3.88258 13.0225 5.4087 12.4167 7 12.4167C8.5913 12.4167 10.1174 13.0225 11.2426 14.1008C12.3679 15.1791 13 16.6417 13 18.1667V19.125ZM13 19.125H19V18.1667C19.0001 17.1573 18.723 16.1656 18.1965 15.2914C17.6699 14.4172 16.9125 13.6912 16.0004 13.1864C15.0882 12.6816 14.0535 12.4159 13.0002 12.4159C11.9469 12.4158 10.9122 12.6815 10 13.1862M11 5.70833C11 6.725 10.5786 7.70002 9.82843 8.41891C9.07828 9.1378 8.06087 9.54167 7 9.54167C5.93913 9.54167 4.92172 9.1378 4.17157 8.41891C3.42143 7.70002 3 6.725 3 5.70833C3 4.69167 3.42143 3.71665 4.17157 2.99776C4.92172 2.27887 5.93913 1.875 7 1.875C8.06087 1.875 9.07828 2.27887 9.82843 2.99776C10.5786 3.71665 11 4.69167 11 5.70833Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Note = (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none">
    <path
      d="M5 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H13C13.5304 19 14.0391 18.7893 14.4142 18.4142C14.7893 18.0391 15 17.5304 15 17V5C15 4.46957 14.7893 3.96086 14.4142 3.58579C14.0391 3.21071 13.5304 3 13 3H11M5 3C5 3.53043 5.21071 4.03914 5.58579 4.41421C5.96086 4.78929 6.46957 5 7 5H9C9.53043 5 10.0391 4.78929 10.4142 4.41421C10.7893 4.03914 11 3.53043 11 3M5 3C5 2.46957 5.21071 1.96086 5.58579 1.58579C5.96086 1.21071 6.46957 1 7 1H9C9.53043 1 10.0391 1.21071 10.4142 1.58579C10.7893 1.96086 11 2.46957 11 3M8 10H11M8 14H11M5 10H5.01M5 14H5.01"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Rates = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M13 5V13V5ZM9 8V13V8ZM5 11V13V11ZM3 17H15C15.5304 17 16.0391 16.7893 16.4142 16.4142C16.7893 16.0391 17 15.5304 17 15V3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V15C1 15.5304 1.21071 16.0391 1.58579 16.4142C1.96086 16.7893 2.46957 17 3 17Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Template = (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none">
    <path
      d="M5 11H11H5ZM8 8V14V8ZM13 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H8.586C8.8512 1.00006 9.10551 1.10545 9.293 1.293L14.707 6.707C14.8946 6.89449 14.9999 7.1488 15 7.414V17C15 17.5304 14.7893 18.0391 14.4142 18.4142C14.0391 18.7893 13.5304 19 13 19Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CurrencyDollar = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 6C8.343 6 7 6.895 7 8C7 9.105 8.343 10 10 10C11.657 10 13 10.895 13 12C13 13.105 11.657 14 10 14V6ZM10 6C11.11 6 12.08 6.402 12.599 7L10 6ZM10 6V5V6ZM10 6V14V6ZM10 14V15V14ZM10 14C8.89 14 7.92 13.598 7.401 13L10 14ZM19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CurrencyPound = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="#4A5568"
      strokeWidth="2"
      d="M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const FolderDownload = (
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="1 3 21 22"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="#4A5568"
      strokeWidth={2}
      d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    />
  </svg>
);

export const FileDownload = (
  <svg
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="#4A5568"
      strokeWidth="2"
      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
    ></path>
  </svg>
);

export const Lock = (
  <svg
    width="19"
    height="21"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 9.25V6.75C3.25 5.0924 3.90848 3.50269 5.08058 2.33058C6.25269 1.15848 7.8424 0.5 9.5 0.5C11.1576 0.5 12.7473 1.15848 13.9194 2.33058C15.0915 3.50269 15.75 5.0924 15.75 6.75V9.25C16.413 9.25 17.0489 9.51339 17.5178 9.98223C17.9866 10.4511 18.25 11.087 18.25 11.75V18C18.25 18.663 17.9866 19.2989 17.5178 19.7678C17.0489 20.2366 16.413 20.5 15.75 20.5H3.25C2.58696 20.5 1.95107 20.2366 1.48223 19.7678C1.01339 19.2989 0.75 18.663 0.75 18V11.75C0.75 11.087 1.01339 10.4511 1.48223 9.98223C1.95107 9.51339 2.58696 9.25 3.25 9.25ZM13.25 6.75V9.25H5.75V6.75C5.75 5.75544 6.14509 4.80161 6.84835 4.09835C7.55161 3.39509 8.50544 3 9.5 3C10.4946 3 11.4484 3.39509 12.1517 4.09835C12.8549 4.80161 13.25 5.75544 13.25 6.75Z"
      fill="#2F80ED"
    />
  </svg>
);

export const Arrow = (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.23401 0.63462C7.38403 0.484643 7.58748 0.400391 7.79961 0.400391C8.01174 0.400391 8.21519 0.484643 8.36521 0.63462L13.1652 5.43462C13.3152 5.58464 13.3994 5.78809 13.3994 6.00022C13.3994 6.21235 13.3152 6.4158 13.1652 6.56582L8.36521 11.3658C8.21433 11.5115 8.01225 11.5922 7.80249 11.5904C7.59273 11.5885 7.39208 11.5044 7.24375 11.3561C7.09543 11.2077 7.01129 11.0071 7.00947 10.7973C7.00765 10.5876 7.08828 10.3855 7.23401 10.2346L10.6684 6.80022H1.39961C1.18744 6.80022 0.983953 6.71593 0.833924 6.5659C0.683895 6.41588 0.599609 6.21239 0.599609 6.00022C0.599609 5.78805 0.683895 5.58456 0.833924 5.43453C0.983953 5.2845 1.18744 5.20022 1.39961 5.20022H10.6684L7.23401 1.76582C7.08403 1.6158 6.99978 1.41235 6.99978 1.20022C6.99978 0.988088 7.08403 0.784642 7.23401 0.63462Z"
      fill="#2F80ED"
    />
  </svg>
);

export const Dollar = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 6C8.343 6 7 6.895 7 8C7 9.105 8.343 10 10 10C11.657 10 13 10.895 13 12C13 13.105 11.657 14 10 14V6ZM10 6C11.11 6 12.08 6.402 12.599 7L10 6ZM10 6V5V6ZM10 6V14V6ZM10 14V15V14ZM10 14C8.89 14 7.92 13.598 7.401 13L10 14ZM19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentText = (
  <svg
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="#4A5568"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    ></path>
  </svg>
);

export const Bell = (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none">
    <path
      d="M12 15H6M12 15H17L15.595 13.595C15.4063 13.4063 15.2567 13.1822 15.1546 12.9357C15.0525 12.6891 15 12.4249 15 12.158V9C15.0002 7.75894 14.6156 6.54834 13.8992 5.53489C13.1829 4.52144 12.17 3.75496 11 3.341V3C11 2.46957 10.7893 1.96086 10.4142 1.58579C10.0391 1.21071 9.53043 1 9 1C8.46957 1 7.96086 1.21071 7.58579 1.58579C7.21071 1.96086 7 2.46957 7 3V3.341C4.67 4.165 3 6.388 3 9V12.159C3 12.697 2.786 13.214 2.405 13.595L1 15H6H12ZM12 15V16C12 16.7956 11.6839 17.5587 11.1213 18.1213C10.5587 18.6839 9.79565 19 9 19C8.20435 19 7.44129 18.6839 6.87868 18.1213C6.31607 17.5587 6 16.7956 6 16V15H12Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InvoiceRemindersIcon = (
  <svg
    width="24"
    height="24"
    fill="none"
    stroke="#4A5568"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    ></path>
  </svg>
);

export const CustomersIcon = (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="#4A5568"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);

export const BulkInvoicesIcon = (
  <svg
    className="w-6 h-6"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const MoreIcon = (
  <svg
    className="w-6 h-6"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
  </svg>
);

export const Edit = () => (
  <svg width="20" viewBox="0 0 20 20" fill="#aab7c6">
    <path
      fill="none"
      stroke="#aab7c6"
      strokeWidth="2"
      d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"
    ></path>
    <path
      fillRule="evenodd"
      d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const AccountBalance = () => (
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.496 0.132166C8.34494 0.0458752 8.17397 0.000488281 8 0.000488281C7.82603 0.000488281 7.65506 0.0458752 7.504 0.132166L0.504 4.13217C0.312671 4.24162 0.162867 4.41122 0.0778804 4.61461C-0.0071063 4.81799 -0.0225134 5.04375 0.0340548 5.2568C0.0906229 5.46984 0.215996 5.65822 0.390682 5.79266C0.565367 5.92709 0.779575 6.00004 1 6.00017V13.0002C0.734784 13.0002 0.48043 13.1055 0.292893 13.2931C0.105357 13.4806 0 13.7349 0 14.0002C0 14.2654 0.105357 14.5197 0.292893 14.7073C0.48043 14.8948 0.734784 15.0002 1 15.0002H15C15.2652 15.0002 15.5196 14.8948 15.7071 14.7073C15.8946 14.5197 16 14.2654 16 14.0002C16 13.7349 15.8946 13.4806 15.7071 13.2931C15.5196 13.1055 15.2652 13.0002 15 13.0002V6.00017C15.2204 6.00004 15.4346 5.92709 15.6093 5.79266C15.784 5.65822 15.9094 5.46984 15.9659 5.2568C16.0225 5.04375 16.0071 4.81799 15.9221 4.61461C15.8371 4.41122 15.6873 4.24162 15.496 4.13217L8.496 0.132166ZM4 7.00017C3.73478 7.00017 3.48043 7.10552 3.29289 7.29306C3.10536 7.4806 3 7.73495 3 8.00017V11.0002C3 11.2654 3.10536 11.5197 3.29289 11.7073C3.48043 11.8948 3.73478 12.0002 4 12.0002C4.26522 12.0002 4.51957 11.8948 4.70711 11.7073C4.89464 11.5197 5 11.2654 5 11.0002V8.00017C5 7.73495 4.89464 7.4806 4.70711 7.29306C4.51957 7.10552 4.26522 7.00017 4 7.00017ZM7 8.00017C7 7.73495 7.10536 7.4806 7.29289 7.29306C7.48043 7.10552 7.73478 7.00017 8 7.00017C8.26522 7.00017 8.51957 7.10552 8.70711 7.29306C8.89464 7.4806 9 7.73495 9 8.00017V11.0002C9 11.2654 8.89464 11.5197 8.70711 11.7073C8.51957 11.8948 8.26522 12.0002 8 12.0002C7.73478 12.0002 7.48043 11.8948 7.29289 11.7073C7.10536 11.5197 7 11.2654 7 11.0002V8.00017ZM12 7.00017C11.7348 7.00017 11.4804 7.10552 11.2929 7.29306C11.1054 7.4806 11 7.73495 11 8.00017V11.0002C11 11.2654 11.1054 11.5197 11.2929 11.7073C11.4804 11.8948 11.7348 12.0002 12 12.0002C12.2652 12.0002 12.5196 11.8948 12.7071 11.7073C12.8946 11.5197 13 11.2654 13 11.0002V8.00017C13 7.73495 12.8946 7.4806 12.7071 7.29306C12.5196 7.10552 12.2652 7.00017 12 7.00017Z"
      fill="white"
    />
  </svg>
);

export const CheckCircle = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8.5C0 3.80558 3.58172 0 8 0C12.4163 0.00501605 15.9953 3.80768 16 8.5C16 13.1944 12.4183 17 8 17C3.58172 17 0 13.1944 0 8.5ZM6.68957 11.9651L12.4039 5.8937C12.6178 5.65841 12.6178 5.2854 12.4039 5.05011C12.1846 4.80895 11.8229 4.80226 11.5959 5.03521L6.28557 10.6774L4.40384 8.67807C4.39922 8.67298 4.39453 8.66804 4.38978 8.66313C4.16277 8.43018 3.80103 8.43687 3.58179 8.67807C3.36255 8.91926 3.36884 9.30362 3.59585 9.53656L5.88158 11.9651C6.1047 12.2022 6.46641 12.2022 6.68957 11.9651Z"
      fill="#2D9BDC"
    />
  </svg>
);

export const Check = () => (
  <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
    <path
      d="M1.33325 5.6665L3.99992 8.33317L10.6666 1.6665"
      stroke="#4285F4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Clock = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path
      d="M11.993 3.16262L12.0576 3.08599L11.9809 3.02155L9.4892 0.930721L9.41278 0.866591L9.34847 0.942864L8.64972 1.77161L8.5851 1.84825L8.66189 1.91268L11.1536 4.00351L11.23 4.06764L11.2943 3.99137L11.993 3.16262ZM4.33252 1.91269L4.40903 1.84851L4.34495 1.77191L3.65162 0.943158L3.58744 0.866443L3.51074 0.930639L1.01907 3.01606L0.942106 3.08047L1.0068 3.1572L1.70555 3.98595L1.76985 4.06221L1.84627 3.99811L4.33252 1.91269ZM6.87075 4.33316V4.23316H6.77075H5.95825H5.85825V4.33316V7.58316V7.63978L5.9068 7.66891L8.47972 9.21266L8.56486 9.26374L8.61655 9.17897L9.0228 8.51272L9.07552 8.42625L8.98839 8.37462L6.87075 7.11992V4.33316ZM6.49992 2.06649C3.75261 2.06649 1.52492 4.29418 1.52492 7.04149C1.52492 9.78873 3.74712 12.0165 6.49992 12.0165C9.24723 12.0165 11.4749 9.7888 11.4749 7.04149C11.4749 4.29418 9.24723 2.06649 6.49992 2.06649ZM6.49992 10.7332C4.4589 10.7332 2.80825 9.08251 2.80825 7.04149C2.80825 5.00047 4.4589 3.34982 6.49992 3.34982C8.54094 3.34982 10.1916 5.00047 10.1916 7.04149C10.1916 9.08251 8.54094 10.7332 6.49992 10.7332Z"
      fill="#443100"
      stroke="#443100"
      strokeWidth="0.2"
    />
  </svg>
);

export const ErrorOutline = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M6 3.77778V6M6 8.22222H6.00556M11 6C11 6.65661 10.8707 7.30679 10.6194 7.91342C10.3681 8.52005 9.99983 9.07124 9.53553 9.53553C9.07124 9.99983 8.52005 10.3681 7.91342 10.6194C7.30679 10.8707 6.65661 11 6 11C5.34339 11 4.69321 10.8707 4.08658 10.6194C3.47995 10.3681 2.92876 9.99983 2.46447 9.53553C2.00017 9.07124 1.63188 8.52005 1.3806 7.91342C1.12933 7.30679 1 6.65661 1 6C1 4.67392 1.52678 3.40215 2.46447 2.46447C3.40215 1.52678 4.67392 1 6 1C7.32608 1 8.59785 1.52678 9.53553 2.46447C10.4732 3.40215 11 4.67392 11 6Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
